import { IDeviceIdWeightIdDto } from 'api/api';
import actionCreatorFactory from 'typescript-fsa';
import { constants } from './constants';

const actionCreator = actionCreatorFactory('adminstration');

export const getDeviceIdWeightIdsAction = actionCreator.async<undefined, IDeviceIdWeightIdDto[]>(
	constants.GET_DEVICEID_WEIGHTIDS
);
